import { useQuery } from '../../../ReactQuery';
import { get } from '../../../redux/api';
import type { Organization } from '../../../types';

//  Fetch the organization for the given organization ID.
const fetchOrganization = async (organizationId: number) => {
  return get<Organization>(`/api/organizations/${organizationId}`);
};

/**
 * The unique query key for the organization query.
 *
 * @param {number} organizationId - The ID of the organization to fetch.
 * @returns {string[]} The query key.
 */
export const getOrganizationQueryKey = (organizationId: number) => ['organization', organizationId];

/**
 * Fetches the organization for the given organization ID.
 *
 * @param {number} organizationId - The ID of the organization to fetch.
 * @returns {Organization} The organization.
 */
export default function useOrganization(organizationId: number) {
  return useQuery({
    queryKey: getOrganizationQueryKey(organizationId),
    queryFn: () => fetchOrganization(organizationId),
  });
}
